export const operatorList = [
  {
    code: "1",
    title: "Airtel",
    type: "prepaid",
    image: "assets/images/airtel_logo.png",
  },
  {
    code: "2",
    title: "BSNL Topup",
    type: "prepaid",
    image: "assets/images/bsnl_logo.png",
  },
  {
    code: "3",
    title: "BSNL Special",
    type: "prepaid",
    image: "assets/images/bsnl_logo.png",
  },
  {
    code: "4",
    title: "JIO",
    type: "prepaid",
    image: "assets/images/jio_logo.png",
  },
  {
    code: "84",
    title: "JIO - Live",
    type: "prepaid",
    image: "assets/images/jio_logo.png",
  },
  {
    code: "5",
    title: "Vi",
    type: "prepaid",
    image: "assets/images/vi_logo.png",
  },
  {
    code: "6",
    title: "Airtel Digital TV",
    type: "dth",
    image: "assets/images/airtel_digital_tv_logo.png",
  },
  {
    code: "7",
    title: "Dish TV",
    type: "dth",
    image: "assets/images/dish_tv_logo.png",
  },
  {
    code: "8",
    title: "Sun Direct",
    type: "dth",
    image: "assets/images/sun_direct_logo.png",
  },
  {
    code: "9",
    title: "Tata Sky",
    type: "dth",
    image: "assets/images/tata_sky_logo.png",
  },
  {
    code: "10",
    title: "Videocon D2H",
    type: "dth",
    image: "assets/images/videocon_d2h_logo.png",
  },
  {
    code: "47",
    title: "Google Play",
    type: "google_play",
    image: "assets/images/google-play-logo.png",
  },
];
